const UserAgreementVersion = 1;

export { UserAgreementVersion };
